import * as React from 'react';
import Modal from 'ha/ui/next/Modal';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';

import { withIntl, IntlProps } from 'ha/i18n';
import SvgIcon from 'ha/ui/next/SvgIcon';
import ListBullets1 from 'streamline-icons/list-bullets-1.svg';
import Button from 'ha/ui/next/Button';
import units from 'ha/theme/units';
import SearchMap from '../containers/SearchMap';
import OtherFilterMobile from '../containers/SearchFilters/OtherFilterMobile';

const styles = createStyles({
  otherFilter: {
    position: 'absolute',
    top: units.rem(0.75),
    left: units.rem(0.75),
    background: 'white',
  },
  listView: {
    position: 'absolute',
    top: units.rem(0.75),
    right: units.rem(0.75),
    background: 'white',
    textTransform: 'uppercase',
  },
  icon: {
    marginRight: units.rem(0.5),
    height: units.rem(1.125),
    width: units.rem(1.125),
  },
});

interface Props {
  isMobileMapOpen: boolean;
  isMobileFiltersOpen: boolean;
  toggleMobileMap: () => void;
}

export const MobileMap: React.SFC<
  Props & WithStyles<typeof styles> & IntlProps
> = ({
  classes,
  isMobileMapOpen,
  isMobileFiltersOpen,
  toggleMobileMap,
  intl: { T },
}) => (
  <Modal
    open={isMobileMapOpen && !isMobileFiltersOpen}
    onClose={toggleMobileMap}
  >
    <SearchMap isAutoRefreshButtonVisible={false} isAutoSearchEnabled />
    <div className={classes.otherFilter}>
      <OtherFilterMobile />
    </div>
    <div className={classes.listView}>
      <Button
        color="primary"
        size="medium"
        variant="outlined"
        onClick={toggleMobileMap}
      >
        <SvgIcon children={<ListBullets1 />} className={classes.icon} />
        {T('list view')}
      </Button>
    </div>
  </Modal>
);

export default withIntl(withStyles(styles)(MobileMap));
